import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';
import { notification } from 'antd';
import i18n from 'i18next';

notification.config({
	placement: 'topRight',
	top: 75,
	duration: 2,
});

const createEditableTable = async (newTable) => {
	try {
		const api = await getAPI();
		const { data } = await api.post('editableTable/new', newTable);

		notification.success({
			message: i18n.t('', 'table created'),
			description: i18n.t(''),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.error(error.response);
	}
};

const getEditableTables = async () => {
	try {
		const api = await getAPI();
		const { data } = await api.get('/editableTable/all');
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error(error.response);
	}
};

const getEditableTable = async (viewId, elementId, widgetId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`/editableTable/${viewId}/${elementId}/${widgetId}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error(error.response);
	}
};

const updateTable = async (tableId, tableToUpdate) => {
	try {
		const api = await getAPI();
		const { data } = await api.put(`editableTable/${tableId}`, tableToUpdate);
		notification.success({
			message: i18n.t('table.note-table-edited', 'table updated'),
			description: i18n.t(''),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('table.note-table-edit-error', 'table could not be updated'),
			description: error.message,
		});
		console.error(error.response);
	}
};

const exportTable = async (columns, widgetId, elementId = undefined) => {
	try {
		const api = await getAPI();
		const { data } = await api.post(
			elementId ? `editableTable/export/${widgetId}/${elementId}` : `editableTable/export/${widgetId}`,
			{ columns },
			{
				responseType: 'arraybuffer',
			}
		);

		return data;
	} catch (error) {
		checkAuthError(error);

		console.error(error.response);
	}
};

const evaluateTable = async (elementId, widgets, functionName) => {
	try {
		const api = await getAPI();
		const { data } = await api.post(`editableTable/evaluate/${elementId}?${new URLSearchParams({ functionName })}`, {
			widgets,
		});

		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('evaluateTable', error.response);

		throw new Error(error?.response?.data?.detail || error?.message || error?.response?.statusText || 'Server Error');
	}
};

export { createEditableTable, getEditableTables, updateTable, getEditableTable, exportTable, evaluateTable };
